import CalendarCard from 'Components/Reusable/Cards/CalendarCard';
import React, { Fragment, useEffect, useState } from 'react';
import topIcon from 'Assets/img/svg/activities/topIcon.svg';
import { RootState } from 'ReduxStore/store';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllExercises } from 'ReduxStore/exercises/Action';
import { Routes } from 'Utils';
import { useStyles } from './calandar.style';
import ClipLoader from 'react-spinners/ClipLoader';
import Pagination from '@material-ui/lab/Pagination';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { findMatch, shuffleItems } from 'Helpers';
import Error from 'Components/Timeline/Error';
import { BackButton } from 'Components/Reusable/Buttons/Buttons';
import backButton from 'Assets/img/svg/buttons/back.svg';
import Header from 'Components/Header/Header';
interface RouteParams {
	id: string;
}

const Calendar = () => {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const params = useParams<RouteParams>();
	const allExercises: any = useSelector((state: RootState) => state.exercise['exercises']);
	const errors = useSelector((state: RootState) => state.exercise['error']);
	const [page, setPage] = useState(1);
	const [data, setData] = useState<any>([]);
	const myDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	const matches = useMediaQuery('(max-width:440px)');
	const itemsPerPage = matches ? 8 : 12;
	const calendarColors = ['#46CACC', '#46CACC', '#CDB3D6', '#FFBD89', '#F7967E', '#E7B7C7', '#63BCCC'];
	useEffect(() => {
		GetAllExercises(params.id)(dispatch);
	}, [dispatch]);

	
	useEffect(() => {
		const trimDays = myDays
			.map(animal => animal[0])
			.join(' ')
			.split(' ');
		if (allExercises && allExercises?.length > 0) {
			const me = allExercises?.map((date: any) => ({
				days: trimDays.map((day, i) => ({
					day: day,
					active:
						findMatch(date.frequency.split(', '), myDays).filter(date => date === i).length > 0
							? true
							: false,
				})),
				...date,
			}));
			setData([...me]);
		}
	}, [allExercises]);

	const goBack = () => {
		history.push(Routes.Menu);
	};
	return (
		<Fragment>
			<Header />
			<section className="mx-4">
			<BackButton image={backButton} transparent />
				<section className="d-flex justify-content-center align-items-center my-5">
					<img src={topIcon} alt="" />
				</section>
				<h3 className={classes.description}>
					Rome wasn&apos;t built in a day. Repetition is the key to ensure mastery of a skill. Some skills
					will take months to master. Consistent, daily practice will ensure success. Mark as ‘completed’
					exercises that have been performed 12 or more times by the end of the month.
				</h3>
				<ul className={`${classes.listItems} d-flex flex-wrap mt-4`}>
					{allExercises && allExercises.length > 0 ? (
						data.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((exercise: any, i: any) => (
							<li key={i} className="mx-4 mb-4">
								<Link  style={{textDecoration:'none'}} to={`/exercise/${exercise.id}`}>
								<CalendarCard
									exercise={exercise}
									common={{
										background: shuffleItems(calendarColors),
										width: '288.92px',
										height: '118.1px',
									}}
								/>
								</Link>
							</li>
						))
					) : (
						<div className={classes.loading}>
							{errors ? (
								<Error errors={errors} />
							) : (
								<div className={classes.loading}>
									<h4>Wait a moment ...</h4>
									<ClipLoader color={'#7FD6DD'} loading={true} size={30} />
								</div>
							)}
						</div>
					)}
				</ul>
				{data && data.length > 0 && (
					<Pagination
						count={Math.ceil(data?.length / itemsPerPage)}
						color="primary"
						className={classes.pagination}
						page={page}
						onChange={(event, val) => setPage(val)}
					/>
				)}
			</section>
		</Fragment>
	);
};

export default Calendar;
